import { trim } from './lodashlike';

export const firstCharIsNotSpecialChar = (str) => {
  return RegExp(/^[\p{L}\p{N}\p{M}]/u).test(str);
};

export const checkIfHasAllowedCharacters = (str) => {
  return RegExp(/^[\p{L}\p{N}\p{M}\s:./\-&$#%_@(){}\\]*$/u).test(str);
};

export const checkIfHasAlphaNumeric = (str) => {
  return RegExp(/[\p{L}\p{N}\p{M}]/u).test(str);
};

export const stringOptimumLength = (str, min, max) => {
  if (str && str.length >= min && str.length <= max) {
    return true;
  }

  return false;
};

export const trimObjectValues = (obj) => {
  let newObj = {};
  for (const property of Object.keys(obj)) {
    newObj[property] = trim(obj[property]);
  }
  return newObj;
};
